import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ISICDReport } from './interfaces';

export const getSICDReportList = (data: IDynamicTableParams) => {
  return instance()
    .post<ISICDReport[]>(`/ovksReport/list`, data)
    .then((response) => response.data);
};

export const getSICDReportAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`/ovksReport/availableColumns`)
    .then((response) => response.data);
};

export const getSICDReportAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/ovksReport/availableGroupColumns`)
    .then((response) => response.data);
};

export const downloadPDFReport = (config: AxiosRequestConfig) => {
  return instance()
    .post('/ovksReport/pdfReport', null, config)
    .then((response) => response.data);
};
